export const firebaseConfig = {
  apiKey: "AIzaSyDSaCcuHlIQxzadO7FyKlTshjA7Rq1Plhc",
  authDomain: "bimobiapp.firebaseapp.com",
  projectId: "bimobiapp",
  storageBucket: "bimobiapp.firebasestorage.app",
  messagingSenderId: "734388845114",
  appId: "1:734388845114:web:ba5fd69e52fc6666581303"
}; 